import { AccessPortal, Icon, toast, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Chip, List, ListItem, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { dateToFormat } from 'src/utils/date';
import useStyles from './styles';
import { RESIDENCY_ADDRESS_STATUS } from 'src/constants/residency';
export default function TenantInformation(_ref) {
  let accountId = _ref.accountId,
    action = _ref.action,
    data = _ref.data,
    addresses = _ref.addresses,
    propertyName = _ref.propertyName,
    overviewData = _ref.overviewData,
    changeStatus = _ref.changeStatus,
    _ref$residencyId = _ref.residencyId,
    residencyId = _ref$residencyId === void 0 ? null : _ref$residencyId,
    paperCorrespondenceSetting = _ref.paperCorrespondenceSetting;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleClick = async () => {
    const getUserProfile = async () => {
      const resp = await store.account.reInviteUserAsync.run(accountId);
      return resp;
    };
    getUserProfile().then(resp => {
      if (resp && resp.isSuccessful) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        // parentToggleRefreshCallback && parentToggleRefreshCallback();
        toast('success', {
          body: ['Re-invitation successfully sent']
        });
      }
    });
  };
  const getItem = (iconType, text, value) => /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "lightGrey",
    type: iconType
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t("general.".concat(text)))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, value));
  return /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(ListItem, {
    className: classes.tenantName
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "lightGrey",
    type: "user"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "".concat(data.firstName, " ").concat(data.lastName)), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "light"
  }, t('general.id'), ": ", data.accountCode))), localStorage.getItem('livable_demo_mode') !== 'Demo' && !store.company.companyFeatureStore.disableEnrollResident && /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => {
      action('personal-details');
    },
    'custom-attribute': '449-tenant-information'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", {
    className: classes.emailRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.emailWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "lightGrey",
    type: "mail"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.email
  }, !!data.email && data.email !== 'N/A' || !!data.newEmail ? "".concat(t('general.email'), ": ").concat(data.email ? data.email : data.newEmail) : t('general.email'))), !!data.email && data.email !== 'N/A' || !!data.newEmail ? data.portalAccessDateOnly ? /*#__PURE__*/React.createElement(AccessPortal, {
    tooltipText: t('resident_account.invitation_will_be_sent', {
      date: dateToFormat(data.portalAccessDateOnly),
      interpolation: {
        escapeValue: false
      }
    })
  }) : data.emailConfirmed ? /*#__PURE__*/React.createElement(AccessPortal, {
    tooltipText: t('unit_modal.has_access_to_rp'),
    type: "success"
  }) : /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    'custom-attribute': '450-tenant-information'
  }, /*#__PURE__*/React.createElement(AccessPortal, {
    tooltipText: t('unit_modal.pending_rp_invite'),
    type: "warning"
  })) : /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('general.na')), residencyId && localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement("div", {
    className: classes.paperInvite
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: !!(paperCorrespondenceSetting !== null && paperCorrespondenceSetting !== void 0 && paperCorrespondenceSetting.paperInviteLastSent) && paperCorrespondenceSetting !== null && paperCorrespondenceSetting !== void 0 && paperCorrespondenceSetting.paperInviteLastSent.length ? "Last invited: ".concat(dateToFormat(paperCorrespondenceSetting === null || paperCorrespondenceSetting === void 0 ? void 0 : paperCorrespondenceSetting.paperInviteLastSent)) : 'Currently there is no Paper Invite sent',
    type: !!(paperCorrespondenceSetting !== null && paperCorrespondenceSetting !== void 0 && paperCorrespondenceSetting.paperInviteLastSent) && paperCorrespondenceSetting !== null && paperCorrespondenceSetting !== void 0 && paperCorrespondenceSetting.paperInviteLastSent.length ? 'success-bold' : 'default'
  }, /*#__PURE__*/React.createElement(Chip, {
    color: "success",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-post"
    }),
    variant: !!(paperCorrespondenceSetting !== null && paperCorrespondenceSetting !== void 0 && paperCorrespondenceSetting.paperInviteLastSent) && paperCorrespondenceSetting !== null && paperCorrespondenceSetting !== void 0 && paperCorrespondenceSetting.paperInviteLastSent.length ? 'portal' : 'inactiveIcon',
    size: "big"
  }))))), getItem('phone', 'phone', data.phone || t('general.na')), getItem('group', 'occupancy', overviewData.occupancy), getItem('building', 'unit', overviewData.unitName), propertyName && /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", {
    className: classes.customAddress
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "lightGrey",
    type: "location"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('Property address'))), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, propertyName), /*#__PURE__*/React.createElement(Chip, {
    label: addresses.findIndex(i => i.isPrimary) > -1 ? 'Backup' : 'Primary',
    variant: addresses.findIndex(i => i.isPrimary) > -1 ? 'inactive' : 'success'
  }))))), addresses && addresses.length > 0 && addresses.map(i => {
    if (i.status !== RESIDENCY_ADDRESS_STATUS.pending) {
      var _i$details;
      return /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", {
        className: classes.customAddress
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.customAddressHeader
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.flex
      }, /*#__PURE__*/React.createElement("span", {
        className: classes.iconWrapper
      }, /*#__PURE__*/React.createElement(Icon, {
        state: "lightGrey",
        type: "location"
      })), /*#__PURE__*/React.createElement(Typography, {
        variant: "h6"
      }, "Address")), /*#__PURE__*/React.createElement("div", {
        className: classes.flex
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h6"
      }, "".concat(i.details.street, " ").concat(i.details.city, ", ").concat(i.details.state, " ").concat(i.details.zip).concat((_i$details = i.details) !== null && _i$details !== void 0 && _i$details.secondary ? ', ' + i.details.secondary : '')), /*#__PURE__*/React.createElement(Chip, {
        label: i.isPrimary ? 'Primary' : 'Backup',
        variant: i.isPrimary ? 'success' : 'inactive'
      })))));
    }
  }), addresses && addresses.length > 0 && addresses.map(i => {
    var _i$details2;
    if (i.status === RESIDENCY_ADDRESS_STATUS.pending) return /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", {
      className: classes.customAddress
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressBody
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressBodyTitle
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressBodyTitleData
    }, /*#__PURE__*/React.createElement("span", null, "Requested address"), /*#__PURE__*/React.createElement("b", null, "".concat(i.details.street, " ").concat(i.details.city, ", ").concat(i.details.state, " ").concat(i.details.zip).concat((_i$details2 = i.details) !== null && _i$details2 !== void 0 && _i$details2.secondary ? ', ' + i.details.secondary : ''))), /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressBodyTitleStatus
    }, /*#__PURE__*/React.createElement(Chip, {
      label: i.isPrimary ? 'Primary' : 'Backup',
      variant: i.isPrimary ? 'success' : 'inactive'
    }))), /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressBodyDetails
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressDetails
    }, data.firstName, " ", data.lastName, " has requested to", ' ', i.isPrimary ? 'change the primary' : 'add the', " mailing address. Would you like to approve new address?"), /*#__PURE__*/React.createElement("div", {
      className: classes.flex
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      size: "small",
      onClick: () => changeStatus(i.id, true),
      disabled: store.address.batchGetAddressesAsync.inProgress || store.residencies.getResidencyAddressesAsync.inProgress || store.residencies.updateResidencyAddressStatusAsync.inProgress,
      'custom-attribute': '451-tenant-information'
    }, "Decline"), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      size: "small",
      onClick: () => changeStatus(i.id),
      disabled: store.address.batchGetAddressesAsync.inProgress || store.residencies.getResidencyAddressesAsync.inProgress || store.residencies.updateResidencyAddressStatusAsync.inProgress,
      'custom-attribute': '452-tenant-information'
    }, "Approve"))))));
  }), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "lightGrey",
    type: "calendar-picker"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('unit_modal.billing_date'))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, dateToFormat(overviewData.billingStartDateOnly), " -", ' ', overviewData.leaseEndDateOnly ? dateToFormat(overviewData.leaseEndDateOnly) : t('general.active'))));
}